/* eslint-disable  @typescript-eslint/no-explicit-any */
import { IGetStockDetailResponse } from '~/src/repositories/Stock/models/Stock'
import NoImage from '~/public/assets/no_image.png'
export function convertStockDetail(data: any): IGetStockDetailResponse {
  const item = data.ckdCar
  const convertItem = {
    image: item?.images[0] ?? NoImage,
    name: item?.displayName ?? 'Name',
    maker: item?.makerName ?? 'Maker',
    carName: item?.carName ?? 'Car name',
    modelCode: item?.modelCode ?? 'Mode code',
    price: item?.originalPrice ?? 0,
  }

  return {
    data: {
      item: convertItem,
    },
  }
}
